module.exports = __webpack_public_path__ + "img/member.1b50c6b5.png";